<template>
  <section class="flex-fill-parent">
    <header class="page-header">
      <div class="d-flex flex-column gap-2">
        <nav class="d-flex align-items-center gap-3 fs-14" aria-label="breadcrumb">
          <span class="d-flex align-items-center gap-1">
            <i class="bx bxs-chevron-left" />
            <GuButton variant="link" class="p-0 link-dark link-offset-2" @click="$router.back()">Back</GuButton>
          </span>
        </nav>
        <h1>Company Management History</h1>
      </div>
    </header>

    <GuDatagridServer :config="config" :site-config-name="siteConfigName" class="mx-5" />
  </section>
</template>

<script setup>
import { GuDatagridServer } from '@gu-datagrid-new'
import { GuButton } from '@shared/gu-components/button'

import { COMPANIES_HISTORY_CONFIG } from '@shared/constants/siteContent'

const config = {
  rowsUrl: '/audit/companies',
}

const siteConfigName = COMPANIES_HISTORY_CONFIG
</script>
